// import pako from 'pako';

//origin string
export function zipEncode(data) {
    const utf8Data = encodeURIComponent(data).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1));
    const base64EncodedData = btoa(utf8Data);
    return base64EncodedData;
}

//encoded string
export function zipDecode(data) {
    const base64EncodedData = atob(data);
    const utf8Data = base64EncodedData.split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');
    const originData = decodeURIComponent(utf8Data);
    return originData;
}
